import { Signage } from '../../../Signage';

export const namedValueCache = {
    removeItem(keyName: string): Promise<void> {
        return Signage.platform.deleteNamedValue(keyName);
    },

    getItem(keyName: string, defaultValue: string): Promise<string> {
        return Signage.platform.getNamedValue(keyName, defaultValue);
    },

    setItem(keyName: string, keyValue: string): Promise<void> {
        return Signage.platform.setNamedValue(keyName, keyValue);
    },
};
